module.exports = __webpack_public_path__ + "static/media/Sri.11e29e3f.jpg";